export function CnpjMask(value: string): string {
  if (!value) {
    return null;
  }
  value = value.replace(/\D/g, "");
  const len = value.length;

  if (len < 15) {
    value = value
      .replace(/(\d{2})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1/$2")
      .replace(/(\d{4})(\d{1,2})$/, "$1-$2");
  } else {
    value = value.replace(/^(\d{2})(\d{3})?(\d{3})?(\d{4})?(\d{2})?/, "$1.$2.$3/$4-$5");
  }
  return value.substring(0, 18);
}



// WEBPACK FOOTER //
// ./src/util/Masks/CnpjMask.ts